import React from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { FormGroup, FormControl, FormLabel, Row, Col, Nav, Tab } from "react-bootstrap";
import { IoMdColorFill } from "react-icons/io";
import { FaMagic } from "react-icons/fa";
import { TwitterPicker } from "react-color";
import { FiDelete, FiX, FiClock, FiTrash2 } from "react-icons/fi";
import { ubicationsService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import Switch from "components/Switch";
import * as ubicationsActions from "actions/ubicationsActions";
import { withTranslation } from "react-i18next";
import { isHaddockEnvironment } from "utils/documentUtils";

class UbicationEdit extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		let ubication = {
			name: "",
			description: "",
			enabled: true,
			background_color: "",
			border_color: "",
			lat: "",
			lon: "",
			max_distance: "",
			max_monthly_shifts: "",
		};

		let isEdit = false;

		if (props.ubication) {
			ubication = {
				max_monthly_shifts: "",
				...props.ubication
			};
			if (ubication.max_monthly_shifts === null || ubication.max_monthly_shifts === undefined) {
				ubication.max_monthly_shifts = "";
			}
			isEdit = true;
		}

		this.state = {
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			ubication,
			isBorderPickerVisible: false,
			isBackgroundPickerVisible: false,
		};
	}

	handleChange = (event) => {
		const { ubication } = this.state;

		this.setState({
			ubication: {
				...ubication,
				[event.target.id]: event.target.value,
			},
		});
	};

	handleSwitch = (event) => {
		const { ubication } = this.state;

		this.setState({
			ubication: {
				...ubication,
				[event.target.id]: event.target.checked,
			},
		});
	};

	handleColorChange = ({ hex }, type) => {
		const { ubication } = this.state;

		if (hex === undefined) hex = "";

		this.setState({
			ubication: {
				...ubication,
				[type]: hex,
			},
			isBackgroundPickerVisible: false,
			isBorderPickerVisible: false,
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	handleSubmit = async (event) => {
		event.preventDefault();
		const props = this.props;
		this.setState({ isLoading: true });
		let response = "";

		// if edit => update; else => new
		if (this.state.isEdit) {
			response = await ubicationsService.update(this.state.ubication);
		} else {
			response = await ubicationsService.add(this.state.ubication);
		}

		// console.log(response);

		if (response.ok) {
			this.setState({
				isLoading: false,
				errors: {},
			});
			toastr.success(this.props.t("common.success"), this.props.t("common.changesSaved"));
			if (typeof this.props.getUbications === "function") {
				await this.props.getUbications();
			}
			props.handleClose();
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	useMyLocation = () => {
		if (!navigator.geolocation) {
			toastr.error("Error", this.props.t("ubications.geolocationNotSupported"));
			return;
		}
		console.log(navigator.geolocation);
		navigator.geolocation.getCurrentPosition(
			(position) => {
				const { latitude, longitude } = position.coords;
				console.log(position);
				this.setState((prev) => ({
					ubication: {
						...prev.ubication,
						lat: latitude.toFixed(6),
						lon: longitude.toFixed(6),
					},
				}));
			},
			() => {
				toastr.error("Error", this.props.t("ubications.locationError"));
			}
		);
	};

	render() {
		const { ubication, errors } = this.state;
		var isActive = ubication.enabled;

		const onToggleBackgroundPicker = () =>
			this.setState({
				isBackgroundPickerVisible: !this.state.isBackgroundPickerVisible,
			});
		const onToggleBorderPicker = () =>
			this.setState({
				isBorderPickerVisible: !this.state.isBorderPickerVisible,
			});

		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body">
					<Tab.Container defaultActiveKey="general">
						<Nav variant="tabs" className="mb-4">
							<Nav.Item>
								<Nav.Link eventKey="general">{this.props.t("ubications.form.tabGeneral")}</Nav.Link>
							</Nav.Item>
							{!isHaddockEnvironment() && (
								<Nav.Item>
									<Nav.Link eventKey="gps">{this.props.t("ubications.form.tabGps")}</Nav.Link>
								</Nav.Item>
							)}
							<Nav.Item>
								<Nav.Link eventKey="ia">
									{this.props.t("ubications.form.tabAI")} <FaMagic style={{ marginLeft: "5px" }} />
								</Nav.Link>
							</Nav.Item>
						</Nav>

						<Tab.Content>
							<Tab.Pane eventKey="general" className="pt-3" style={{ minHeight: "auto", paddingBottom: "0" }}>
								<FormGroup className="form-group" controlId="name">
									<FormLabel>
										{this.props.t("ubications.form.name")} <span className="label-required">*</span>
									</FormLabel>
									<FormControl
										type="text"
										value={ubication.name}
										onChange={this.handleChange}
										placeholder={this.props.t("ubications.form.namePlaceholder")}
										isInvalid={this.checkValidField("name")}
									/>

									<FormControl.Feedback type="invalid">
										{errors.name}
									</FormControl.Feedback>
								</FormGroup>

								<FormGroup className="form-group" controlId="description">
									<FormLabel>{this.props.t("ubications.form.description")}</FormLabel>
									<FormControl
										type="text"
										value={ubication.description}
										onChange={this.handleChange}
										placeholder={this.props.t("ubications.form.descriptionPlaceholder")}
										isInvalid={this.checkValidField("description")}
									/>

									<FormControl.Feedback type="invalid">
										{errors.description}
									</FormControl.Feedback>
								</FormGroup>

								<Row>
									<Col sm={6}>
										<FormGroup
											controlId="background_color"
											className="form-group form-color"
										>
											<div className="flex-between">
												<FormLabel>{this.props.t("ubications.form.backgroundColor")}</FormLabel>
												<FiDelete
													className={`icon-remove-color ${!ubication.background_color && "hidden"} `}
													onClick={() =>
														this.handleColorChange("", "background_color")
													}
												/>
											</div>
											<FormControl
												type="text"
												value={ubication.background_color}
												placeholder="#FFFFFF"
												readOnly
												isInvalid={this.checkValidField("background_color")}
												style={{
													backgroundColor:
														ubication.background_color && ubication.background_color,
												}}
												onClick={onToggleBackgroundPicker}
											/>
											<FormControl.Feedback type="invalid">
												{errors.background_color}
											</FormControl.Feedback>

											<IoMdColorFill onClick={onToggleBackgroundPicker} />

											{this.state.isBackgroundPickerVisible && (
												<div style={{ position: "absolute" }}>
													<TwitterPicker
														color={
															ubication.background_color
																? ubication.background_color
																: "#ffffff"
														}
														onChangeComplete={(hex) =>
															this.handleColorChange(hex, "background_color")
														}
													/>
												</div>
											)}
										</FormGroup>
									</Col>
									<Col sm={6}>
										<FormGroup
											controlId="border_color"
											className="form-group form-color"
										>
											<div className="flex-between">
												<FormLabel>{this.props.t("ubications.form.borderColor")}</FormLabel>
												<FiDelete
													className={`icon-remove-color ${!ubication.border_color && "hidden"} `}
													onClick={() => this.handleColorChange("", "border_color")}
												/>
											</div>

											<FormControl
												type="text"
												value={ubication.border_color}
												placeholder="#FFFFFF"
												readOnly
												isInvalid={this.checkValidField("border_color")}
												style={{
													backgroundColor:
														ubication.border_color && ubication.border_color,
												}}
												onClick={onToggleBorderPicker}
											/>
											<FormControl.Feedback type="invalid">
												{errors.border_color}
											</FormControl.Feedback>

											<IoMdColorFill onClick={onToggleBorderPicker} />

											{this.state.isBorderPickerVisible && (
												<div style={{ position: "absolute" }}>
													<TwitterPicker
														color={
															ubication.border_color
																? ubication.border_color
																: "#ffffff"
														}
														onChangeComplete={(hex) =>
															this.handleColorChange(hex, "border_color")
														}
													/>
												</div>
											)}
										</FormGroup>
									</Col>
								</Row>

								<FormGroup
									className="form-group form-group-flex mb0"
									controlId="enabled"
								>
									<FormLabel>{this.props.t("ubications.form.active")}</FormLabel>
									<Switch
										controlId="enabled"
										isOn={isActive}
										handleToggle={this.handleSwitch}
									/>

									<FormControl.Feedback type="invalid">
										{errors.enabled}
									</FormControl.Feedback>
								</FormGroup>
							</Tab.Pane>

							{!isHaddockEnvironment() && (
								<Tab.Pane eventKey="gps" className="pt-3" style={{ minHeight: "auto", paddingBottom: "0" }}>
									<Row>
										<Col sm={12} lg={8}>
											<Row>
												<Col sm={12} lg={6}>
													<FormGroup controlId="lat" className="form-group mb5">
														<FormLabel>{this.props.t("ubications.form.latitude")}</FormLabel>
														<FormControl
															type="text"
															value={ubication.lat}
															placeholder={this.props.t("ubications.form.latitude")}
															isInvalid={this.checkValidField("lat")}
															onChange={this.handleChange}
														/>
														<FormControl.Feedback type="invalid">
															{errors.lat}
														</FormControl.Feedback>
													</FormGroup>
												</Col>
												<Col sm={12} lg={6}>
													<FormGroup controlId="lon" className="form-group mb5">
														<FormLabel>{this.props.t("ubications.form.longitude")}</FormLabel>
														<FormControl
															type="text"
															value={ubication.lon}
															placeholder={this.props.t("ubications.form.longitude")}
															isInvalid={this.checkValidField("lon")}
															onChange={this.handleChange}
														/>
														<FormControl.Feedback type="invalid">
															{errors.lon}
														</FormControl.Feedback>
													</FormGroup>
												</Col>
											</Row>
											<button
												type="button"
												className="btn-link mb30"
												onClick={this.useMyLocation}
											>
												{this.props.t("ubications.form.useMyLocation")}
											</button>
										</Col>
										<Col sm={6} lg={4}>
											<FormGroup controlId="max_distance" className="form-group">
												<FormLabel>{this.props.t("ubications.form.maxDistance")}</FormLabel>
												<div className="input-group">
													<FormControl
														type="text"
														value={ubication.max_distance}
														placeholder={this.props.t("ubications.form.maxDistancePlaceholder")}
														isInvalid={this.checkValidField("max_distance")}
														onChange={this.handleChange}
													/>
													<span className="input-group-text">m</span>
												</div>

												<FormControl.Feedback type="invalid">
													{errors.max_distance}
												</FormControl.Feedback>
											</FormGroup>
										</Col>
									</Row>

									<div className="alert alert-warning mt-3">
										<p className="mb0">
											{this.props.t("ubications.form.gpsWarning")}
										</p>
									</div>
								</Tab.Pane>
							)}

							<Tab.Pane eventKey="ia" className="pt-3" style={{ minHeight: "auto", paddingBottom: "0" }}>
								<FormGroup className="form-group" controlId="max_monthly_shifts">
									<FormLabel>{this.props.t("ubications.form.monthlyShiftLimit")}</FormLabel>
									<FormControl
										type="number"
										min="0"
										step="1"
										value={ubication.max_monthly_shifts}
										onChange={this.handleChange}
										placeholder=""
										isInvalid={this.checkValidField("max_monthly_shifts")}
									/>

									<FormControl.Feedback type="invalid">
										{errors.max_monthly_shifts}
									</FormControl.Feedback>
								</FormGroup>
							</Tab.Pane>
						</Tab.Content>
					</Tab.Container>
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{this.props.t("common.cancel")}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={this.props.t("common.save")}
						loadingText={this.props.t("common.saving")}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.ubicationsReducer;
};

export default connect(mapStateToProps, ubicationsActions)(withTranslation()(UbicationEdit));
// export default connect(mapStateToProps)(FunctionEdit)
